module.exports = __webpack_public_path__ + "img/send_sms.dda9ce75.svg";